import { roles } from '../utils/roles';
import routes from '../utils/routes';

const accessControl = {
    [roles[1]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.userManagement]: ["read", "write"],
            [routes.addUser]: ["read", "write"],
            [routes.editProfile]: ["read", "write"]
        },
        features: {
            documents: [],
            approvableDocuments: {
                PFI: [],
                SI: [],
                CI: [],
                SA: [],
                PL: [],
                BE: [],
                COO: []
            },
            businessUnits: []
        }
    },
    [roles[2]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read", "write"],
            [routes.dealFoods]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.dealPetrochemicals]: ["read", "write"],
            [routes.dealPolymers]: ["read", "write"],
            [routes.dealSBLC]: ["read", "write"],
            [routes.entityCounterParties]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.documentRequests]: ["read", "write"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            documentRequestPermissions: {
                "PFI": ["read"],
                "SI": ["read"],
                "SI Approval": ["read", "write"],
                "Post-Shipment Documents": ["read"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read"],
                "Post Transmission Review of LC": ["read"],
                "LC Ammendments Review": ["read"],
                "BL Draft Review": ["read"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[3]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read"],
            [routes.dealFoods]: ["read"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.dealPetrochemicals]: ["read"],
            [routes.dealPolymers]: ["read"],
            [routes.dealSBLC]: ["read"],
            [routes.documentRequests]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[4]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.entityProducts]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.entityTraders]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read", "write"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read", "write"],
                "SI": ["read", "write"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read", "write"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read", "write"],
                "Post Transmission Review of LC": ["read", "write"],
                "LC Ammendments Review": ["read", "write"],
                "BL Draft Review": ["read", "write"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                }
            ]
        }
    },
    [roles[5]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read", "write"],
            [routes.entityDealPFIs]: ["read", "write"],
            [routes.entityProducts]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.entityTraders]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read", "write"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read"],
                "SI": ["read"],
                "SI Approval": ["read", "write"],
                "Post-Shipment Documents": ["read"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read"],
                "Post Transmission Review of LC": ["read"],
                "LC Ammendments Review": ["read"],
                "BL Draft Review": ["read"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                }
            ]
        }
    },
    [roles[6]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            documentRequestPermissions: {
                "PFI": ["read"],
                "SI": ["read"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read"],
                "Post Transmission Review of LC": ["read"],
                "LC Ammendments Review": ["read"],
                "BL Draft Review": ["read"],
                "KYC": ["read", "write"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                }
            ]
        }
    },
    [roles[7]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read"],
            [routes.dealFoods]: ["read"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.dealPetrochemicals]: ["read"],
            [routes.dealPolymers]: ["read"],
            [routes.dealSBLC]: ["read"],
            [routes.entityCounterParties]: ["read", "write"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.kycCounterPartyList]: ["read", "write"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[8]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read"],
            [routes.dealFoods]: ["read"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.dealPetrochemicals]: ["read"],
            [routes.dealPolymers]: ["read"],
            [routes.dealSBLC]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.periodLockRequests]: ["read", "write"],
            [routes.settings]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[9]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.entityBanks]: ["read", "write"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDropdowns]: ["read", "write"],
            [routes.entityFileTypes]: ["read", "write"],
            [routes.entityProducts]: ["read", "write"],
            [routes.entityTenors]: ["read", "write"],
            [routes.entityTraders]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: [],
            approvableDocuments: {
                PFI: [],
                SI: [],
                CI: [],
                SA: [],
                PL: [],
                BE: [],
                COO: []
            },
            businessUnits: []
        }
    },
    [roles[10]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFoods]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.entityProducts]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.entityTraders]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read", "write"],
                "SI": ["read", "write"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read", "write"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read", "write"],
                "Post Transmission Review of LC": ["read", "write"],
                "LC Ammendments Review": ["read", "write"],
                "BL Draft Review": ["read", "write"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                }
            ]
        }
    },
    [roles[11]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFoods]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read", "write"],
            [routes.entityDealPFIs]: ["read", "write"],
            [routes.entityProducts]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.entityTraders]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read", "write"],
                "SI": ["read", "write"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read", "write"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read", "write"],
                "Post Transmission Review of LC": ["read", "write"],
                "LC Ammendments Review": ["read", "write"],
                "BL Draft Review": ["read", "write"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                }
            ]
        }
    },
    [roles[12]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFoods]: ["read"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            documentRequestPermissions: {
                "PFI": ["read"],
                "SI": ["read"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read"],
                "Post Transmission Review of LC": ["read"],
                "LC Ammendments Review": ["read"],
                "BL Draft Review": ["read"],
                "KYC": ["read", "write"]
            },
            businessUnits: [
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                }
            ]
        }
    },
    [roles[13]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.dealPolymers]: ["read", "write"],
            [routes.dealSBLC]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.entityProducts]: ["read"],
            [routes.entityTraders]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read", "write"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read", "write"],
                "SI": ["read", "write"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read", "write"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read", "write"],
                "Post Transmission Review of LC": ["read", "write"],
                "LC Ammendments Review": ["read", "write"],
                "BL Draft Review": ["read", "write"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[14]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.dealPolymers]: ["read", "write"],
            [routes.dealSBLC]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read", "write"],
            [routes.entityDealPFIs]: ["read", "write"],
            [routes.entityProducts]: ["read"],
            [routes.entityTraders]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read", "write"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read", "write"],
                "SI": ["read", "write"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read", "write"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read", "write"],
                "Post Transmission Review of LC": ["read", "write"],
                "LC Ammendments Review": ["read", "write"],
                "BL Draft Review": ["read", "write"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[15]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.dealPolymers]: ["read"],
            [routes.dealSBLC]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            documentRequestPermissions: {
                "PFI": ["read"],
                "SI": ["read"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read"],
                "Post Transmission Review of LC": ["read"],
                "LC Ammendments Review": ["read"],
                "BL Draft Review": ["read"],
                "KYC": ["read", "write"]
            },
            businessUnits: [
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[16]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.dealPetrochemicals]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.entityProducts]: ["read"],
            [routes.entityTraders]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read", "write"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read", "write"],
                "SI": ["read", "write"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read", "write"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read", "write"],
                "Post Transmission Review of LC": ["read", "write"],
                "LC Ammendments Review": ["read", "write"],
                "BL Draft Review": ["read", "write"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                }
            ]
        }
    },
    [roles[17]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read", "write"],
            [routes.dealPetrochemicals]: ["read", "write"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read", "write"],
            [routes.entityDealPFIs]: ["read", "write"],
            [routes.entityProducts]: ["read"],
            [routes.entityTraders]: ["read"],
            [routes.entitySBLC]: ["read", "write"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read", "write"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.documentRequests]: ["read"],
            [routes.kycNewKYC]: ["read", "write"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.periodLockRequests]: ["read"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read", "write"],
            [routes.approveDocumentsDetails]: ["read", "write"],
            [routes.massUpdate]: ["read", "write"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read", "write"],
                SI: ["read", "write"],
                CI: ["read", "write"],
                SA: ["read", "write"],
                PL: ["read", "write"],
                BE: ["read", "write"],
                COO: ["read", "write"],
                Notify: ["read", "write"]
            },
            documentRequestPermissions: {
                "PFI": ["read", "write"],
                "SI": ["read", "write"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read", "write"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read", "write"],
                "Post Transmission Review of LC": ["read", "write"],
                "LC Ammendments Review": ["read", "write"],
                "BL Draft Review": ["read", "write"],
                "KYC": ["read"]
            },
            businessUnits: [
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                }
            ]
        }
    },
    [roles[18]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.dealPetrochemicals]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.kycRequests]: ["read", "write"],
            [routes.kycRequestsDetails]: ["read", "write"],
            [routes.kycEditKYC]: ["read", "write"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.editProfile]: ["read", "write"],
            [routes.pageNotFound]: ["read", "write"]
        },
        features: {
            documents: ["read", "write"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            documentRequestPermissions: {
                "PFI": ["read"],
                "SI": ["read"],
                "SI Approval": ["read"],
                "Post-Shipment Documents": ["read"],
                "Documentation Approval": ["read"],
                "LC Draft Review": ["read"],
                "Post Transmission Review of LC": ["read"],
                "LC Ammendments Review": ["read"],
                "BL Draft Review": ["read"],
                "KYC": ["read", "write"]
            },
            businessUnits: [
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                }
            ]
        }
    },
    [roles[19]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.dealFertilizers]: ["read"],
            [routes.dealFoods]: ["read"],
            [routes.dealMiscellaneous]: ["read"],
            [routes.dealPetrochemicals]: ["read"],
            [routes.dealPolymers]: ["read"],
            [routes.dealSBLC]: ["read"],
            [routes.entityBanks]: ["read"],
            [routes.entityCounterParties]: ["read"],
            [routes.entityDeals]: ["read"],
            [routes.entityDealPFIs]: ["read"],
            [routes.entityDropdowns]: ["read"],
            [routes.entityFileTypes]: ["read"],
            [routes.entityProducts]: ["read"],
            [routes.entityTenors]: ["read"],
            [routes.entityTraders]: ["read"],
            [routes.reportDealReport]: ["read"],
            [routes.reportPreShipmentReport]: ["read"],
            [routes.reportFinanceReport]: ["read"],
            [routes.reportMorningReport]: ["read"],
            [routes.reportTreasuryReport]: ["read"],
            [routes.reportDocuments]: ["read"],
            [routes.kycRequests]: ["read"],
            [routes.kycRequestsDetails]: ["read"],
            [routes.kycCounterPartyList]: ["read"],
            [routes.approveDocuments]: ["read"],
            [routes.approveDocumentsDetails]: ["read"],
            [routes.editProfile]: ["read", "write"]
        },
        features: {
            documents: ["read"],
            approvableDocuments: {
                PFI: ["read"],
                SI: ["read"],
                CI: ["read"],
                SA: ["read"],
                PL: ["read"],
                BE: ["read"],
                COO: ["read"],
                Notify: ["read"]
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    },
    [roles[20]]: {
        routes: {
            [routes.setNewPassword]: ["read", "write"],
            [routes.landing]: ["read", "write"],
            [routes.auditTrailFinance]: ["read", "write"],
            [routes.auditTrailUser]: ["read", "write"],
            [routes.editProfile]: ["read", "write"]
        },
        features: {
            documents: [],
            approvableDocuments: {
                PFI: [],
                SI: [],
                CI: [],
                SA: [],
                PL: [],
                BE: [],
                COO: []
            },
            businessUnits: [
                {
                    id: 2,
                    value: "Fertilizers"
                },
                {
                    id: 4,
                    value: "Foods"
                },
                {
                    id: 5,
                    value: "Miscellaneous"
                },
                {
                    id: 3,
                    value: "Petrochemicals/Feedstocks"
                },
                {
                    id: 1,
                    value: "Polymers"
                },
                {
                    id: 6,
                    value: "SBLC"
                }
            ]
        }
    }
};

export default accessControl;

export const checkPermission = (role, route, action) => {
    const roleAccess = accessControl[role];

    // Return false if role is not defined
    if (!roleAccess) {
        return false;
    }

    // Normalize route by removing trailing slash
    const normalizedRoute = route.replace(/\/$/, "");

    // Check for an exact match first
    if (roleAccess.routes[normalizedRoute]?.includes(action)) {
        return true;
    }

    // Check for dynamic routes and their static prefixes
    for (const definedRoute of Object.keys(roleAccess.routes)) {
        if (definedRoute.includes(":")) {
            // Convert dynamic route to regex (e.g., "/kyc/requests/:kyc_id" -> "^/kyc/requests/([^/]+)$")
            const pattern = definedRoute.replace(/:[^/]+/g, "([^/]+)");
            const regex = new RegExp(`^${pattern}$`);

            // Check if route matches the dynamic pattern
            if (regex.test(normalizedRoute)) {
                return roleAccess.routes[definedRoute]?.includes(action) || false;
            }

            // Check if route matches the static prefix of the dynamic route
            const staticPrefix = definedRoute.split("/:").at(0);
            if (normalizedRoute === staticPrefix && roleAccess.routes[definedRoute]?.includes(action)) {
                return true;
            }
        }
    }

    // Return false if route is not defined or action is not allowed
    return false;
};


const getRoutePermissions = (roleAccess, route) => {
    // Return default permissions if roleAccess or routes is not defined
    if (!roleAccess || !roleAccess.routes) {
        return { isReadable: false, isWritable: false };
    }

    // Normalize route: remove query parameters and trailing slash
    const normalizedRoute = route.split('?')[0].replace(/\/$/, '');

    // Check for exact match first
    const exactPermissions = roleAccess.routes[normalizedRoute] || [];
    if (exactPermissions.length > 0) {
        return {
            isReadable: exactPermissions.includes('read'),
            isWritable: exactPermissions.includes('write')
        };
    }

    // Check for dynamic routes and their static prefixes
    for (const definedRoute of Object.keys(roleAccess.routes)) {
        if (definedRoute.includes(':')) {
            // Convert dynamic route to regex (e.g., "/documents/approve-documents/:deal_no" -> "^/documents/approve-documents/([^/]+)$")
            const pattern = definedRoute.replace(/:[^/]+/g, '([^/]+)');
            const regex = new RegExp(`^${pattern}$`);

            // Check if route matches the dynamic pattern
            if (regex.test(normalizedRoute)) {
                const permissions = roleAccess.routes[definedRoute] || [];
                return {
                    isReadable: permissions.includes('read'),
                    isWritable: permissions.includes('write')
                };
            }

            // Check if route matches the static prefix of the dynamic route
            const staticPrefix = definedRoute.split('/:')[0];
            if (normalizedRoute === staticPrefix) {
                const permissions = roleAccess.routes[definedRoute] || [];
                return {
                    isReadable: permissions.includes('read'),
                    isWritable: permissions.includes('write')
                };
            }
        }
    }

    // Return false for unmatched routes (no * route defined in roleAccess.routes)
    return { isReadable: false, isWritable: false };
};


const getFeaturePermissions = (roleAccess, feature) => {
    const featureAccess = roleAccess.features?.[feature];

    if (!featureAccess) return null;

    if (typeof featureAccess === "object" && !Array.isArray(featureAccess)) {
        return Object.entries(featureAccess).reduce((acc, [key, permissions]) => {
            acc[key] = {
                isReadable: permissions.includes("read"),
                isWritable: permissions.includes("write")
            };
            return acc;
        }, {});
    }
    else if (feature === "businessUnits") {
        return roleAccess.features?.businessUnits || [];
    }
    else if (feature === "documents") {
        const documents = roleAccess.features?.documents || [];

        return {
            isReadable: documents.includes("read"),
            isWritable: documents.includes("write")
        };
    }

    return null;
};

export const getPermissions = (role, route = null, feature = null) => {
    const roleAccess = accessControl[role];

    // Return default permissions (none) if the role is undefined
    if (!roleAccess) {
        return { isReadable: false, isWritable: false };
    }

    if (route) {
        // Get permissions for the route
        return getRoutePermissions(roleAccess, route);
    }
    else if (feature) {
        // Get permissions for the feature
        return getFeaturePermissions(roleAccess, feature);
    }

    // Default return if neither route nor feature is provided
    return { isReadable: false, isWritable: false };
};